module.exports = __webpack_public_path__ + "img/cnps.2c0feb94.jpeg";